import { cn } from "@/lib/utils";

type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center" | "right";
  className?: string;
  eyebrowClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
};

export function SectionHeading({
  eyebrow,
  title,
  description,
  align = "center",
  className,
  eyebrowClassName,
  titleClassName,
  descriptionClassName,
}: SectionHeadingProps) {
  const alignClassName =
    align === "left" ? "text-left" : align === "right" ? "text-right" : "text-center";

  return (
    <div className={cn(alignClassName, className)}>
      {eyebrow ? (
        <p
          className={cn(
            "text-[clamp(12px,1.1vw,20px)] font-normal leading-tight tracking-[0.22em] text-muted-foreground",
            eyebrowClassName,
          )}
        >
          {eyebrow}
        </p>
      ) : null}
      <h2
        className={cn(
          "mt-2 text-[clamp(28px,3.2vw,48px)] font-medium leading-[1.1] tracking-tight text-foreground",
          titleClassName,
        )}
      >
        {title}
      </h2>
      {description ? (
        <p
          className={cn(
            "mt-3 text-[clamp(13px,1.05vw,16px)] leading-relaxed text-muted-foreground",
            descriptionClassName,
          )}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
}

